<template>
  <div class="s-financialApplyFor-container container financialApplyFor">
    <topNav></topNav>
    <div class="topBg">
        <div class="banner w1300 marginAuto"></div>
      </div>
    <div class="section w1300 marginAuto">
      <div class="crumbs">
        <img src="../assets/image/index/home.png" class="img" alt />
        <span v-if="showCrumbs == 'index'" @click="goRoute('index')" class="go">首页&gt;</span>
        <span @click="goRoute('financialInsurance')" class="go">金融保险&gt;</span>
        <span>金融服务申请</span>
      </div>
      <div class="top-part">
        <img :src="financialObj.img" class="bankLogo" alt />
        <div class="content">
          <p class="title">{{ financialObj.institutionName }} —— {{financialObj.productsName}}</p>
          <div class="type">
            <div class="type-part">
              <p class="val">
                {{ financialObj.quotaStart }}万~{{ financialObj.quotaEnd }}万
              </p>
              <p class="name">贷款额度</p>
            </div>
            <div class="type-part">
              <p class="val">
                {{ financialObj.rateStart }}%~{{ financialObj.rateEnd }}%
              </p>
              <p class="name">参考利率</p>
            </div>
            <div class="type-part">
              <p class="val">
                {{ financialObj.termStart }}~{{ financialObj.termEnd }}年
              </p>
              <p class="name">贷款期限</p>
            </div>
            <div class="type-part">
              <p class="val">{{ financialObj.guaranteeTypeValue }}</p>
              <p class="name">抵押贷款</p>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-part">
        <div class="title1">
          <span class="name">申请信息表</span>
          <span class="detail">(以下信息必填)</span>
        </div>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
          <div class="title2">贷款信息</div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="贷款额度：" prop="lines">
                <el-input v-model.trim="form.lines" maxlength="12" class="ipt-select-w"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="贷款用途：" prop="uses">
                <el-input v-model.trim="form.uses" maxlength="20" class="ipt-select-w"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="贷款期限：" prop="deadline">
                <el-input v-model.trim="form.deadline" maxlength="2" class="ipt-select-w"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行卡：" prop="bankCard">
                <el-select v-model="form.bankCard" class="ipt-select-w" placeholder="请选择">
                  <el-option v-for="item in bankCardOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="title2">个人信息</div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="申请人姓名：" prop="name">
                <el-input v-model.trim="form.name" maxlength="6" class="ipt-select-w"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别：" prop="sex">
                <el-input v-model.trim="form.sex" maxlength="1" class="ipt-select-w"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="手机号：" prop="phone">
                <el-input v-model.trim="form.phone" maxlength="11" class="ipt-select-w"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号：" prop="idNumber">
                <el-input v-model.trim="form.idNumber" maxlength="18" class="ipt-select-w"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="居住所在地：" prop="residence">
                <el-input v-model.trim="form.residence" maxlength="20" class="ipt-select-w"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="户籍所在地：" prop="domicilePlace">
                <el-input v-model.trim="form.domicilePlace" maxlength="20" class="ipt-select-w"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="详细地址：" prop="address">
                <el-input v-model.trim="form.address" maxlength="20" class="ipt-select-w"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="户籍地址：" prop="censusRegisterAddress">
                <el-input v-model.trim="form.censusRegisterAddress" maxlength="20" class="ipt-select-w"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="上传抵押证：">
                <el-upload class="avatar-uploader" action :show-file-list="false" :on-change="handleUploadChange" :auto-upload="false">
                  <!-- :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"-->
                  <img v-if="form.mortgageCertificate" :src="form.mortgageCertificate" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <!-- <el-upload
                  action="#"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog> -->
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="divBtn">
          <el-button size="mini" class="cancelBtn btn" @click.stop="goRoute('financialInsurance')">取消申请</el-button>
          <el-button size="mini" class="submitBtn btn" @click.stop="handleSubmit('form')">提交申请</el-button>
        </div>
      </div>
    </div>
    <footerNav></footerNav>
    <!-- <el-dialog
      title="提示信息"
      :visible.sync="submitDialogVisible"
      class="hintDialog"
      width="30%"
      :close-on-click-modal="false"
      :before-close="handleClose"
      center
    >
      <div class="content">
        <div class="gifBox">
          <div class="gifBg">{{ clock }}</div>
        </div>
        <div class="msg">
          {{ hintMsg }}
        </div>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";
import validate from "../utils/js/validator"; //检验
import {
  uploadImg,
  addApplyLoan,
  getFinancialProductsListPage,
  getBankCard,
} from "../utils/api/financialInsurance";
export default {
  name: "financialApplyFor",
  components: { topNav, footerNav },
  data() {
    return {
      showCrumbs: "financialInsurance",
      financialObj: {},
      form: {
        // quota:''
        mortgageCertificate: "",
      },
      bankCardOptions: [
        {
          value: "01",
          label: "中国工商银行",
        },
        {
          value: "02",
          label: "中国银行",
        },
      ],
      // dialogImageUrl: "",
      // dialogVisible: false,
      submitDialogVisible: false,
      rules: {
        lines: [
          { required: true, message: "请输入贷款额度", trigger: "blur" },
          {
            validator: validate.FormValidate.Form().priceProp,
            trigger: "blur",
          },
        ],
        uses: [{ required: true, message: "请输入贷款用途", trigger: "blur" }],
        deadline: [
          { required: true, message: "请输入贷款期限", trigger: "blur" },
          {
            validator: validate.FormValidate.Form().priceProp,
            trigger: "blur",
          },
        ],
        bankCard: [
          { required: true, message: "请选择开户行卡", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入申请人姓名", trigger: "blur" },
          {
            validator: validate.FormValidate.Form().validateName,
            trigger: "blur",
          },
        ],
        sex: [
          { required: true, message: "请输入性别", trigger: "blur" },
          {
            validator: validate.FormValidate.Form().sexy,
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: validate.FormValidate.Form().validatePhone,
            trigger: "blur",
          },
        ],
        idNumber: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            validator: validate.FormValidate.Form().validateIdCode,
            trigger: "blur",
          },
        ],
        residence: [
          { required: true, message: "请输入居住所在地", trigger: "blur" },
        ],
        domicilePlace: [
          { required: true, message: "请输入户籍所在地", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        censusRegisterAddress: [
          { required: true, message: "请输入户籍地址", trigger: "blur" },
        ],
        // dialogImageUrl: [{ required: true, message: "请选择抵押证", trigger: "blur" }],
      },
      clock: 10,
      timmer: null,
      hintMsg:
        "您好，您的贷款申请已经已经提交成功，审核周期为5~12个工作日，请您耐心等待！",
      id: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      defaultImg: require("../assets/image/dealmakers/default.png"),
      routeParams: "",
    };
  },
  mounted() {
    if (this.$route.query.from) {
      this.id = this.$route.query.id;
      if (this.$route.query.from == "index") {
        this.showCrumbs = "index";
      } else if (this.$route.query.from == "financialInsurance") {
        this.showCrumbs = "financialInsurance";
      }
    }
    this.getFinancialProductsListPage();
    this.getBankCard();
  },
  methods: {
    async getBankCard() {
      let res = await getBankCard({ codeType: "bank_type" });
      // console.log("getBankCard", res);
      if (res.data.code == 0) {
        this.bankCardOptions = res.data.data.map((item) => {
          return {
            value: item.codeValue,
            label: item.codeName,
          };
        });
      }
    },
    goRoute(url) {
      this.$router.push({ path: url });
    },
    //分页获取参数
    async getFinancialProductsListPage() {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      let res = await getFinancialProductsListPage(params);
      console.log("res", res);
      if (res.data.code == 0) {
        res.data.data.records.forEach((item) => {
          if (this.id == item.id) {
            this.financialObj = item;
          }
        });
        console.log("this.financialObj", this.financialObj);
        if (this.financialObj.img != null) {
          this.financialObj.img =
            this.imgURL + "/" + this.financialObj.img.split(",")[0];
        } else {
          this.financialObj.img = this.defaultImg;
        }
        this.total = res.data.data.total;
      }
    },
    handleSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (JSON.parse(this.$store.state.isLogin)) {
            this.submitDialogVisible = true;
            this.setTime();
            this.form.productsId = this.id;
            this.form.remark = this.form.name;
            this.form.institutionId = this.financialObj.institutionId;
            let data = this.form;
            let res = await addApplyLoan(data);
            if (res.data.code == 0) {
              this.$message({
                type: "success",
                message: "提交成功!",
              });
              if (this.showCrumbs == "index") {
                this.$router.push({ path: "index" });
              } else {
                this.$router.push({ path: "personalCenter" });
              }
            } else if (res.code === -1) {
              this.$message({
                type: "warning",
                message: res.msg,
              });
              return false;
            }
          } else {
            return this.$message({
              type: "warning",
              message: "请先登录!",
            });
          }
        } else {
          return false;
        }
      });

      // this.$notify({
      //   title: "成功",
      //   message: "申请成功",
      //   type: "success"
      // });
    },
    handleClose() {
      this.submitDialogVisible = false;
      clearTimeout(this.timmer);
      this.clock = 10;
    },
    // 倒计时函数封装
    setTime() {
      if (this.clock === 0) {
        this.submitDialogVisible = false;
        this.clock = 10;
        return;
      } else {
        this.clock--;
      }
      this.timmer = setTimeout(() => {
        this.setTime();
      }, 1000);
    },
    // 上传 交易产品图片
    handleUploadChange(file) {
      this.uploadImg(file.raw);
    },
    // 上传源文件
    async uploadImg(file) {
      let fd = new FormData();
      fd.append("file", file); //传文件
      let params = {
        folder: "img",
      };
      const res = await uploadImg(fd, params);
      this.form.mortgageCertificate = this.imgURL + "/" + res.data;
    },
  },
};
</script>

<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/financialInsuranceApplyFor.scss";
</style>
<style lang="scss" scoped></style>
